import { theme } from '../../../../../../common/theme';
import { styled } from '../../../../../../providers/context/StyletronProvider/withStyletronProvider';

export const Paragraph = styled('div', ({ $theme }: any) => ({
  ...theme.fonts.headingLarge,
  color: $theme.colors.primaryActive,
  marginTop: `-${theme.unit[4]}`,
  marginBottom: theme.unit[2],
}));
